const About = () => {
	return (
		<>
			<div className="  ">
				<div>
					<h1 className="text-center text-4xl m-5">About me</h1>
					{/* <span className=" text-2xl">Agne Postnikova</span> */}
					<div className="text-base/loose font-light flex justify-around">
						<div className="mx-12 mb-5">
							<div className="divider"></div>
							<span className="font-serif">Who is Agne Postnikova?</span>
							<p>
								Hi there! First of all, thank you for taking the time to look at
								my portfolio. You probably want to know more about who I am, my
								background and ect.. <br />
								My name is quite forign, it's pronounced "Ag-nee-ah". I was born
								and raised in Ireland, because my parents are forign (what a
								surprise!) I grew up with three languages. Those are English,
								Lithuanian and Russian. Ever since I was little, i've been very
								shy, I am more than happy to meet new people, to make
								connections but once I do, people say I am a very sweet and
								thoughtful person. Once people get to know me better, I am very
								bubbly. I work in a very nice cafe/resuatrant as a waitress.
								Since this is my first "official" job, I had a lot to learn, but
								my manager who works with us on the floor, immediately noticed
								how willing I am to learn and how hard I try to achieve what I
								can. This is something I will bring into the real world.
							</p>
						</div>
						<div className="mx-12 mb-5">
							<div className="divider"></div>
							<span className="font-serif">What is my education?</span>
							<p>
								I currently am in College, attending the Institute of Art,
								Design and Technology in Dun Laoghire, Dublin. If everything
								goes to plan, I am to graduate in 2025 with a Level 8 Bachelors
								of Science (Honours) Degree, in Creative Computing. I am really
								happy that I took this course over any other. It covers such a
								wide range of skills, from UI/UX design, to Back-End
								Development. I think this is very important for young
								individuals because we get to explore so much, and we learn what
								we like and don't like. For me personally, I really love design,
								UI/UX. I preform well in most things, but what i enjoy the most
								is designing. I am a team player, I work well with people and
								can achieve a lot as a team. I think this is very important when
								it comes to designing a website because everyone will have their
								own input, and we will have the best output as a team. <br />
								Most of my projects in college are solo, but the ones that were
								group projects, I really enjoyed. Communicating in a team is key
								to success (as cheesy as it sounds, it is true) and I believe I
								can bring this to a professional work enviornment.
							</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default About;
